import type { FlowMedia } from '@/types';
import { MediaType } from '@/types';
import getMediaTypeFromString from '@/utils/generation/getMediaTypeFromString';

import type { PollResponse } from './pollRequest';

const buildFlowMediaFromPollResponse = (
  id: string,
  response: PollResponse['response']
): FlowMedia | null => {
  if (!response || !response.result || response.result.length === 0) {
    return null;
  }

  const firstResult = response.result[0];
  const resultType = firstResult?.type?.toLowerCase();
  const mediaType = getMediaTypeFromString(resultType);
  const isVideo = mediaType === MediaType.VIDEO;
  const posterUrl = isVideo ? firstResult.result?.frames?.first : undefined;

  return {
    id,
    type: mediaType,
    url: firstResult.result?.url,
    width: firstResult.result?.metadata?.width,
    height: firstResult.result?.metadata?.height,
    driveUid: firstResult.driveUid,
    poster: posterUrl,
  };
};

export default buildFlowMediaFromPollResponse;
